import React, { useMemo } from "react";
import {
  Box,
  CircularProgress,
  ListSubheader,
  List,
  Typography,
  Divider
} from "@material-ui/core";
import moment from "moment";
import { MobilePOSPurchase } from "../../../../models/MobilePOS";

import { ShoppingCart } from "@material-ui/icons";
import useStyles from "../../styles";
import { Currency } from "../../../../components/misc/Currency";
import { useI18n } from "../../../../hooks/useI18n";

export const MobilePOSPurchases = ({
  isLoading,
  purchases
}: {
  isLoading: boolean;
  purchases: MobilePOSPurchase[];
}) => {
  const classes = useStyles();
  const { t } = useI18n();
  return (
    <Box display="block" position="relative">
      <List
        component="nav"
        subheader={
          <ListSubheader
            component="div"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Typography
              color="textPrimary"
              variant="button"
              style={{ paddingTop: 7, paddingBottom: 7 }}
            >
              {t("common.tabs.payments")}
            </Typography>
          </ListSubheader>
        }
      >
        <Divider style={{ marginBottom: "1rem" }} />
        {isLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="200px"
          >
            <CircularProgress />
          </Box>
        ) : purchases?.length ? (
          purchases.slice(0, 10).map((purchase, index) => (
            <Box
              key={index}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              p={2}
              style={{
                borderBottom: "1px solid #ddd"
              }}
            >
              <Box display="flex" alignItems="center">
                <ShoppingCart color="primary" style={{ marginRight: 8 }} />
                <Typography className={classes.text}>
                  <Currency value={purchase.amount} />
                </Typography>
              </Box>

              <Typography className={classes.text}>
                {`${t("common.messages.time")}: ${moment(
                  purchase.created
                ).format("HH:mm")}`}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography style={{ textAlign: "center" }}>
            {t("common.messages.noPaymentsAvailable")}
          </Typography>
        )}
      </List>
    </Box>
  );
};
